import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=0069af6a&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=0069af6a&prod&lang=css"
import style1 from "./index copy.vue?vue&type=style&index=1&id=0069af6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069af6a",
  null
  
)

export default component.exports